// Please update robots.ts file when adding a new route path
export const ROUTES = {
	HOME: '/',
	CATEGORIES: '/categories',
	INDUSTRIES: '/industries',
	CART: '/cart',
	CHECKOUT: '/cart/checkout',
	THANKYOU: '/cart/checkout/thank-you',
	ORDERS: '/orders',
	INVOICES: '/invoices',
	INVOICE_PAID_RELATIVE: '/thank-you',
	PRODUCTS: '/products',
	PRODUCT_SEARCH: '/products?search=',
	LOGIN: '/login',
	LOGOUT: '/logout',
	FAQ: '/faq',
	ADDRESSES: '/addresses',
	FAVORITES: '/favorites',
	QUICK_ORDER: '/quick-order',
	CONFIGURE_RELATIVE: '/configure',
	PENDING_APPROVAL: '/login/pending-approval',
	SESSION_EXPIRED: '/session-expired',
	SHARED_CART: '/shared-carts',
};
